import initSharedPromotion from '@resources/js/components/promotion/initSharedPromotion'
import { getBcomOrExpediaPartnerType } from '@resources/js/components/promotion/helpers/getPartnerType'
import inViewport from '@resources/js/helpers/inViewport'
import MapView from '@resources/js/maps/MapView'
import MapHotelsStore from '@resources/js/maps/MapStores/MapHotelsStore'

import FormView from '@resources/js/components/form/FormView'
import FormStore from '@resources/js/components/form/FormStore'
import { syncFormStoreWithSession } from '@resources/js/components/form/formStoreSync'
import FormPresenter from '@resources/js/components/form/FormPresenter'
import handleCalendarFormSubmit from '@resources/js/helpers/handleCalendarFormSubmit'
import '@resources/js/analytics'

const partnerType = getBcomOrExpediaPartnerType()

initSharedPromotion()

// map
inViewport('#mapbox', () => {
	const map = new MapView({ zoom: 12 })
	const mapHotelsStore = new MapHotelsStore()
	const data = mapHotelsStore.getData()
	map.addMarkers(data)
	map.fitByCoords(mapHotelsStore.getCoordinates())
})

// main form
const mainFormElement = document.querySelector('.js-form')

const formStore = new FormStore()
syncFormStoreWithSession(formStore)
const mainFormView = new FormView(mainFormElement)
const mainFormPresenter = new FormPresenter(mainFormView, formStore)

mainFormPresenter.on('form-submit', formData =>
	handleCalendarFormSubmit({ partnerType, formData })
)
